"use client";

import { useState } from "react";
import "./switch-custom.css"; // Import custom switch styles
import { Switch } from "antd";

export default function DeactivateAccount() {
  const [deactivateAccount, setDeactivateAccount] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [password, setPassword] = useState("");
  const [understood, setUnderstood] = useState(false);

  const handleDeactivateChange = () => {
    setDeactivateAccount(!deactivateAccount);
    if (!deactivateAccount) {
      setDeleteAccount(false);
    }
  };

  const handleDeleteChange = () => {
    setDeleteAccount(!deleteAccount);
    if (!deleteAccount) {
      setDeactivateAccount(false);
    }
  };

  const handleCancel = () => {
    console.log("Cancel clicked");
  };

  const handleDelete = () => {
    console.log("Delete clicked", {
      deactivateAccount,
      deleteAccount,
      password,
      understood,
    });
  };

  return (
    <div className="max-w-md  bg-white p-[16px]">
      <h1 className="text-[18px] font-semibold font-poppins text-[#171717] mb-2">
        Deactivate / Delete Account (Managed by Admin)
      </h1>
      <p className="text-[#171717] text-[14px] font-poppins mb-8">
        Take a break or delete your account permanently.
      </p>

      <div className="space-y-6">
        {/* Deactivate Account Toggle */}
        <div className="flex items-center justify-between">
          <span className="text-[#171717] text-[14px] font-poppins">
            Deactivate My Account
          </span>

          <Switch
            disabled
            checked={deactivateAccount}
            onChange={(e) => setDeactivateAccount(e.target.checked)}
            className="custom-switch"
          />
        </div>

        {/* Delete Account Toggle */}
        <div className="flex items-center justify-between">
          <span className="text-[#171717] text-[14px] font-poppins">
            Delete My Account Permanently
          </span>

          <Switch
            disabled
            checked={deleteAccount}
            onChange={(e) => setDeleteAccount(e.target.checked)}
            className="custom-switch"
          />
        </div>

        {deleteAccount && (
          <p className="text-gray-600 text-sm -mt-2">
            All data will be removed permanently
          </p>
        )}

        {/* Password Input */}
        <div className="space-y-2">
          <label className="block text-[#171717] text-[16px] font-poppins">
            6-Digit OTP
          </label>
          <input
            type="password"
            placeholder="Type here"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="rounded-[12px] py-[16px] px-[16px] bg-[#F8FAFC] font-poppins w-full"
          />
        </div>

        {/* Checkbox */}
        <div className="flex items-start space-x-3">
          <div className="flex items-center h-5">
            <input
              type="checkbox"
              checked={understood}
              onChange={(e) => setUnderstood(e.target.checked)}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
          </div>
          <label className="text-[#171717] text-[14px] font-poppins">
            I understand the consequences
          </label>
        </div>

        {/* Buttons */}
        <div className="flex space-x-3 pt-4">
          <button
            onClick={handleCancel}
            className="flex-1 p-[12px] w-[124px] h-[40px] bg-[#FFFFFF] border-[1px] rounded-[8px] border-[#4B61FF] text-[#4B61FF] font-poppins"
            style={{
              border: "1px solid #4B61FF",
            }}
          >
            Cancel
          </button>
          <button
            disabled
            onClick={handleDelete}
            // disabled={
            //   !understood || (!deactivateAccount && !deleteAccount) || !password
            // }
            className="flex-1 p-[12px] w-[124px] h-[40px] bg-[#C7C7C7] border-[1px] rounded-[8px] border-[#4B61FF] text-[#FFFFFF] font-poppins"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
